
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"120","height":"120"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"fill":"#FFD250","d":"M22 46l7.951 42h71.901L106 46z"}}),_c('g',{attrs:{"stroke":"#000"}},[_c('path',{attrs:{"d":"M11 51.612h98M103 52l-8.223 43H25.908L17 52"}})]),_c('g',{attrs:{"stroke":"#000"}},[_c('path',{attrs:{"d":"M49.578 25.231L25 51.535M69.578 25.231l24.578 26.304"}})]),_c('g',{attrs:{"stroke":"#000"}},[_c('path',{attrs:{"d":"M40.5 59v25M60.5 59v25M80.5 59v25"}})])])])
          )
        }
      }
    